import * as React from "react";
import { MbnIcon } from "sb-resp-ui";
import { getDictPhrase } from "../../../../helpers";
import { FastMarketIcon } from "../FastMarketIcon";
import { LiveStreamingIcon } from "../LiveStreamingIcon";
import { PulseBetIcon } from "../PulseBetIcon";
import { StatisticsIcon } from "../StatisticsIcon";
export const IconsController = (props) => {
    let firstIcon, secondIcon;
    if (props.event.mbnIcon && props.event.mbnIcon.active) {
        firstIcon = React.createElement(MbnIcon, { tagNumber: props.event.mbnIcon.tagNumber });
        secondIcon = getFirstAvailableIcon(props, true);
    }
    else {
        firstIcon = getFirstAvailableIcon(props, false);
        secondIcon = React.createElement(LiveStreamingIcon, { hasLiveStream: props.event.livestreamIcon.active, tooltip: getDictPhrase(props.dict, props.event.livestreamIcon.tooltip), showEmptyIcon: false, handler: props.handlers.liveStream });
    }
    return React.createElement(React.Fragment, null,
        firstIcon,
        secondIcon);
};
const getFirstAvailableIcon = (details, shouldShowLiveStreaming) => {
    if (shouldShowLiveStreaming && details.event.livestreamIcon.active) {
        return React.createElement(LiveStreamingIcon, { hasLiveStream: details.event.livestreamIcon.active, tooltip: getDictPhrase(details.dict, details.event.livestreamIcon.tooltip), showEmptyIcon: false, handler: details.handlers.liveStream });
    }
    if (details.isDesktop) {
        if (details.event.statisticsIcon.active) {
            return React.createElement(StatisticsIcon, { hasStatistics: details.event.statisticsIcon.active, tooltip: getDictPhrase(details.dict, details.event.statisticsIcon.tooltip), handler: details.handlers.statistics });
        }
    }
    else {
        if (details.event.pulsebetIcon.active) {
            return React.createElement(PulseBetIcon, { hasPulseBet: details.event.pulsebetIcon.active, tooltip: getDictPhrase(details.dict, details.event.pulsebetIcon.tooltip) });
        }
    }
    return React.createElement(FastMarketIcon, { hasFastMarket: details.event.fastmarketIcon.active, tooltip: getDictPhrase(details.dict, details.event.fastmarketIcon.tooltip) });
};
//# sourceMappingURL=IconsController.js.map